// @deprecated use `import { Typograph } from '@nesto/design-system';` instead
export { Typograph } from '@nesto/design-system';
